import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Bento } from "../components/landing/Bento";
import { Teaser } from "../components/landing/Teaser";
import { Faq } from "../components/landing/Faq";
import { Footer } from "../components/Footer";
import { TierCards } from "../components/TierCards";
import { Reveal } from "../components/Reveal";
import { useAuth } from "../context/AuthContext";
import { formatError, startCheckout } from "../lib/api";

export default function Landing() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);

  const onSelect = async (tier) => {
    if (!user) return navigate(`/auth?mode=signup&tier=${tier}`);
    setLoading(tier);
    try {
      await startCheckout({ kind: "tier", tier });
    } catch (e) {
      toast.error(formatError(e));
      setLoading(null);
    }
  };

  return (
    <main data-testid="landing-page">
      <Hero />
      <Marquee />
      <Bento />
      <section id="tiers" data-testid="tiers-section" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-32">
        <Reveal className="grid lg:grid-cols-12 gap-8 mb-16">
          <p className="eyebrow lg:col-span-3">02 — Membership</p>
          <div className="lg:col-span-9">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0E1B3D]">Choose <span className="italic text-[#D7263D]">how close</span> you want to be.</h2>
            <p className="mt-5 text-base text-[#4A5878] max-w-xl">Monthly memberships. Upgrade whenever you like.</p>
          </div>
        </Reveal>
        <TierCards currentTier={user?.tier} loading={loading} onSelect={onSelect} />
      </section>
      <Teaser />
      <Faq />
      <Footer />
    </main>
  );
}
